import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { utils } from '@atlaskit/util-service-support';
import { timed } from './timing';
import { limitToMaxSiteUsage } from './multi-site-utils';
import { sitesToLocations, SEARCH_QUERY } from './graphql-tools';
export { CONFLUENCE_ITEM_ENTITIES } from './graphql-tools';
export var GraphQLClient = /*#__PURE__*/function () {
  function GraphQLClient(_ref) {
    var _this = this;
    var url = _ref.url,
      cloudId = _ref.cloudId,
      siteMasterList = _ref.siteMasterList;
    _classCallCheck(this, GraphQLClient);
    _defineProperty(this, "makePostRequest", function (path, body) {
      var options = {
        path: path,
        requestInit: {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        }
      };
      return utils.requestService(_this.serviceConfig, options);
    });
    this.serviceConfig = {
      url: url
    };
    this.cloudId = cloudId;
    this.siteMasterList = siteMasterList;
  }
  _createClass(GraphQLClient, [{
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var query, context, entities, modelParams, resultLimit, filters, experience, _ref2$sites, sites, cloudId, cloudIdsToFilterOn, locations, body, _yield$timed, response, requestDurationMs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = _ref2.query, context = _ref2.context, entities = _ref2.entities, modelParams = _ref2.modelParams, resultLimit = _ref2.resultLimit, filters = _ref2.filters, experience = _ref2.experience, _ref2$sites = _ref2.sites, sites = _ref2$sites === void 0 ? [] : _ref2$sites;
              cloudId = this.cloudId;
              cloudIdsToFilterOn = sites.length > 0 ? sites : limitToMaxSiteUsage(this.siteMasterList).map(function (site) {
                return site.cloudId;
              });
              locations = sitesToLocations(cloudIdsToFilterOn, cloudId);
              body = {
                query: SEARCH_QUERY,
                variables: {
                  locations: locations,
                  entities: entities,
                  query: query,
                  confluenceFilters: filters,
                  experience: experience
                }
              };
              _context.next = 7;
              return timed(this.makePostRequest(GraphQLClient.GRAPHQL_API_URL, body));
            case 7:
              _yield$timed = _context.sent;
              response = _yield$timed.result;
              requestDurationMs = _yield$timed.durationMs;
              return _context.abrupt("return", {
                response: {
                  rawData: response
                },
                requestDurationMs: requestDurationMs
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function search(_x) {
        return _search.apply(this, arguments);
      }
      return search;
    }()
  }]);
  return GraphQLClient;
}();
// Static URLs
_defineProperty(GraphQLClient, "GRAPHQL_API_URL", 'graphql');